import { Component, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ParkingSpaceDto } from '../../../api/gen';
import { ParkingSpaceItemComponent } from "../parking-space-item/parking-space-item.component";
import { PageEvent } from '@angular/material/paginator';
import { PaginationConfig } from '../../models/config/pagination-config';
import { CommonModule } from '@angular/common';
import { JJamesPaginationConfig, ResponsiveBaseComponent, JJamesPaginatorComponent } from 'shared-lib';

@Component({
  selector: 'app-parking-space-list',
  imports: [CommonModule, JJamesPaginatorComponent, ParkingSpaceItemComponent],
  templateUrl: './parking-space-list.component.html',
  styleUrl: './parking-space-list.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ParkingSpaceListComponent extends ResponsiveBaseComponent {
  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() parkingSpaceDeleted = new EventEmitter<string>();
  @Input() parkingSpaces: ParkingSpaceDto[] = [];
  @Input() paginationConfig: PaginationConfig | null = new PaginationConfig(20, 1, 0);

  showValidationErrorsFor: string | null = null;

  onPageChange($event: PageEvent) {
    this.pageChange.emit($event);
  }

  onParkingSpaceDeleted(parkingSpaceId: string) {
    this.parkingSpaceDeleted.emit(parkingSpaceId);
  }

  get jjamesPaginationConfig(): JJamesPaginationConfig | null {
    if (!this.paginationConfig) return null;

    return {
      currentPage: this.paginationConfig.currentPage,
      totalPages: Math.ceil(this.paginationConfig.totalItems / this.paginationConfig.itemsPerPage),
      pageSize: this.paginationConfig.itemsPerPage,
      totalItems: this.paginationConfig.totalItems,
      itemsPerPage: this.paginationConfig.itemsPerPage,
      pageSizeOptions: [5, 10, 25, 100]
    };
  }
}
